<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-formacion-academica />
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Formacion académica y bachillerato
    </h3>

    <ver-documento />
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                dark
                @click.native.stop="crearActualizarFormacionAcademica({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Formacion academica</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <!-- <td class="text-xs-center">{{ items.item.nombre }}</td> -->
            <td class="text-xs-center">{{ 
              
              items.item.institucion? items.item.institucion.nombre_institucion: "" }}</td>
            <td class="text-xs-center">{{items.item.carrera ? items.item.carrera.nombre_carrera :""}}</td>
            <td class="text-xs-center">{{ $moment(items.item.fecha_conclusion).format("DD/MM/YYYY") }}</td>
            <td class="text-xs-center">{{ items.item.titulado ? 'Si' : 'No' }}</td>
            <td class="text-xs-center">{{ items.item.parametro_estudio ? items.item.parametro_estudio.valor :""}}</td>
            <td class="text-xs-center">{{ items.item.titulo_obtenido? items.item.titulo_obtenido: "No" }}</td>
            
            <td class="text-xs-center">{{ items.item.url_documento ? 'Si' : 'No'}}</td>

            <td class="nowrap text-xs-center">
              <v-tooltip bottom v-if="estado==1 || rol!=42">
                <v-btn
                  icon
                  slot="activator"
                  color="primary"
                  @click.native="crearActualizarFormacionAcademica(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="items.item.url_documento!=null"> 
                <v-btn
                  color="green"
                  
                  dark
                  icon
                  slot="activator"
                  @click.native="verDocumento(items.item)"
                >
                  <v-icon color="dark">visibility</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="estado==1 || rol!=42">
                <v-btn
                  icon
                  slot="activator"
                  color="error"
                  @click="
                    deleteItem(items.item.id, 'formacionAcademica')
                  "
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarFormacionAcademica from "../dialogs/CrearActualizarFormacionAcademica"; // Componente de creación y actualización
import VerDocumento from "../dialogs/VerDocumento.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  props: ["persona"],
  // Variables iniciales del componente
  data() {
    return {
      url: "formacionAcademicas",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Universidad o Instituto", value: "id_institucion", align: "center" },
        { text: "Carrea o Área de formación", value: "id_carrera", align: "center" },
        {
          text: "Fecha de conclusión",
          value: "fecha_conclusion",
          align: "center"
        },
        { text: "Titulado", value: "titulado", align: "center" },
        { text: "Estudios", value: "parametro_estudio", align: "center" },
        { text: "Título obtenido", value: "titulo_obtenido", align: "center" },
        { text: "Documento adjunto", value: "url_documento", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        id_estado
          id_institucion
          id_carrera
          id_profesion
          institucion{
            id
            nombre_institucion
          }
          carrera{
            id 
            nombre_carrera
          }
          profesion{
            id
            nombre_profesion
          }
          url_documento
          fecha_inicio
          fecha_conclusion
          titulado
          titulo_obtenido
          fecha_ta
          numero_ta
          fecha_tpn
          numero_tpn
          parametro_estudio{
            id
            valor
          }
          id_parametro_ta
          id_parametro_tpn
          id_estado
          id_persona
          id_parametro_ano_universitario
          parametro_ta{
            id
            valor
          }
          parametro_tpn{
            id
            valor
          }

        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [],
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id
        }
      ],
      estado:[],
      rol:[]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    this.$bus.$on("verDocumento", item => {
      this.url = item;
      this.dialog = true;
    });
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.obtenerEstadoFicha();
  },
  // Métodos y funciones del componente
  methods: {
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    crearActualizarFormacionAcademica(item) {
      this.$bus.$emit("openDialogCrearActualizarFormacionAcademica", item);
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
      this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarFormacionAcademica,
    VerDocumento
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/FormacionAcademica.vue